import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { TranslateService } from '@ngx-translate/core';
import { PR_ERROR_MESSAGES } from '../models/pr-error-code';

export enum NOTIFICATION_TYPE {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}
@Injectable({ providedIn: 'root' })
export class ErrorHandlingService {
  constructor(
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
  ) {}

  trimPrPrefix(errorCode: string | number): number | null {
    if (typeof errorCode === 'string' && errorCode.startsWith('PR-')) {
      const num = Number(errorCode.replace('PR-', ''));
      return isNaN(num) ? null : num;
    }
    if (typeof errorCode === 'number') {
      return errorCode;
    }
    return null;
  }

  handle(
    error: any,
    fallbackMessage?: string,
    showNotification: boolean = true,
    notificationType: NOTIFICATION_TYPE = NOTIFICATION_TYPE.ERROR,
  ): void {
    let message = fallbackMessage;
    let errorCode = '';

    const resolveMappedMessage = (code: string | number | undefined): string | undefined => {
      if (code === undefined || code === null) {
        return undefined;
      }

      const rawCode = typeof code === 'number' ? code.toString() : code;
      if (rawCode && PR_ERROR_MESSAGES[rawCode]) {
        return PR_ERROR_MESSAGES[rawCode];
      }

      const normalizedCode = this.trimPrPrefix(code);
      if (normalizedCode !== null) {
        return PR_ERROR_MESSAGES[normalizedCode.toString()];
      }

      return undefined;
    };

    if (error instanceof HttpErrorResponse) {
      if (error.error) {
        message = fallbackMessage || 'An error occurred.';
        errorCode = error.error.errorCode || '';
        const mappedMessage = resolveMappedMessage(errorCode);
        if (mappedMessage) {
          message = mappedMessage;
        }
      }
    } else if (error?.errorCode) {
      const mappedMessage = resolveMappedMessage(error.errorCode);
      if (mappedMessage) {
        message = mappedMessage;
      }
      errorCode = error.errorCode;
    } else if (typeof error === 'string') {
      message = error;
    }

    if (showNotification) {
      const resolvedMessage = message ? this.translateService.instant(message) : message;
      this.notificationService[notificationType](resolvedMessage);
    }
  }
}
